import api, { ApiRequest, ApiResult } from '../api/api-caller';

export interface RangeColor {
  id: string;
  rangecolor: string;
}

const fetchRangeColors = async (measureIds: String[]): Promise<ApiResult> => {
  const rangeColorQuery: ApiRequest = {
    body: {
      query: `[${measureIds.join()}]`,
      attributes: 'rangecolor'
    },
    method: 'POST'
  };
  const rangeColorsResult: ApiResult = await api.asyncCallApi('meaquery', rangeColorQuery);

  return rangeColorsResult;
};

const getRangeColors = (rangeColorsResult: ApiResult): RangeColor[] => {
  return rangeColorsResult.data;
};

export { fetchRangeColors, getRangeColors };
